<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title> My Competitions </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="searchQuery"
        append-icon="mdi-magnify"
        label="Search"
        style="max-width: 15rem"
        left
        hide-details
        class="ml-3 mt-2"
      ></v-text-field>
      <v-select
        :items="options"
        item-text="text"
        item-value="value"
        v-model="selectedOption"
        @change="fetchCompetition(selectedOption)"
        class="ml-4 mt-7"
        style="max-width: 11rem; cursor: pointer"
      ></v-select>
    </v-toolbar>
    <v-container fluid>
      <v-row class="ma-1" v-if="filteredCompetitions.length > 0">
        <v-col
          cols="4"
          v-for="(comp, index) in filteredCompetitions"
          :key="index"
        >
          <v-card width="100%" height="100%" class="ma-1 pa-4">
            <v-img width="100%" height="100" :src="comp.thumbnail"></v-img>
            <v-chip label :class="`fixedbtn ${getChipColor(comp.state)}`"
              >{{ comp.state }}
            </v-chip>
            <v-row class="ma-1">
              <v-col cols="12" class="pa-0">
                <v-card-title class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ comp.name }}</span>
                    </template>
                    <span v-if="comp.name.length <= 20">{{ comp.name }}</span>
                    <span v-else>{{ comp.name.substring(0, 20) + "..." }}</span>
                  </v-tooltip>
                </v-card-title>
              </v-col>
            </v-row>
            <v-row class="ma-1">
              <v-col cols="12" class="pa-0 mt-1">
                <span class="grey--text"
                  >Prize Pool
                  <span class="primary--text font-weight-bold"
                    >{{
                      comp.coinsPerQuestion *
                      comp.quizes[0].quizQuestions.length
                    }}
                  </span>
                  <img
                    style="height: 1.2rem"
                    class="ml-1 mb-n1"
                    src="../assets/Coin.svg"
                  />
                </span>
              </v-col>
            </v-row>
            <v-row class="ma-1">
              <span
                class="mt-1"
                style="font-size: 0.8rem; color: grey"
                v-if="comp.state == COMP_STATE_UPCOMING"
              >
                <v-col class="pa-0" cols="12">
                  <span>Starts in: </span>
                  <span class="font-weight-bold">
                    {{ comp.timeStartDifference }}
                  </span>
                </v-col>
              </span>
            </v-row>
            <v-row class="ma-1">
              <span
                class="mt-1"
                style="font-size: 0.8rem; color: grey"
                v-if="
                  comp.state == COMP_STATE_UPCOMING ||
                  (comp.state == COMP_STATE_LIVE &&
                    comp.isAlreadyAttempted == false)
                "
              >
                <v-col class="pa-0" cols="12">
                  <span>Ends in: </span>
                  <span class="font-weight-bold">
                    {{ comp.timeEndDifference }}
                  </span>
                </v-col>
              </span>
            </v-row>
            <v-row class="ma-1">
              <span
                class="mt-1"
                style="font-size: 0.8rem; color: grey"
                v-if="
                  comp.state == COMP_STATE_LIVE &&
                  comp.isAlreadyAttempted == true
                "
              >
                <v-col class="pa-0" cols="12">
                  <span>Result in: </span>
                  <span class="font-weight-bold">
                    {{ comp.timeResultDifference }}
                  </span>
                </v-col>
              </span>
            </v-row>
            <v-card-actions class="pa-0">
              <v-row
                class="ma-1"
                v-if="
                  comp.state == COMP_STATE_LIVE &&
                  comp.isAlreadyAttempted == false
                "
              >
                <v-btn
                  width="100%"
                  color="primary"
                  @click="$refs.competitionInstructions.openTestDialog(comp)"
                >
                  Attempt
                </v-btn>
              </v-row>
              <v-row
                class="ma-1 d-flex justify-center"
                v-else-if="
                  comp.state == COMP_STATE_LIVE &&
                  comp.isAlreadyAttempted == true
                "
              >
                <v-chip
                  label
                  class="white--text d-flex justify-center"
                  color="grey"
                  style="width: 100%"
                >
                  ATTEMPTED
                </v-chip>
              </v-row>
              <v-row
                class="ma-1"
                v-else-if="
                  comp.state != COMP_STATE_LIVE &&
                  comp.isAlreadyAttempted == true
                "
              >
                <v-btn width="100%" color="primary" @click="analyseComp(comp)">
                  <v-icon class="mr-1">mdi-poll</v-icon>
                  View Analytics
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else-if="loading == false">
        <v-col class="text-center">
          <v-row class="text-center">
            <v-col class="text-center">
              <img height="300" src="../assets/oops.png" alt="img" />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="text-center">
              <span class="text-h2 font-weight-medium">
                No
                <span :style="{ color: currentState.color }">{{
                  currentState.text
                }}</span>
                Competitions found
              </span>
              <br />
              <span class="grey--text toxt-body-1">
                Check for
                <span :style="{ color: nextState.color }">{{
                  nextState.text
                }}</span>
                Competitions
                <span
                  style="color: blue; cursor: pointer"
                  @click="fetchCompetition(currentState.next)"
                >
                  <u>here</u></span
                >
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <CompetitionInstructions ref="competitionInstructions" />
    <CompetitionFinishedDailog ref="competitionFinishedDialog" />
  </div>
</template>
<script>
import {
  GET_ALL_STUDENT_COMPETITIONS,
  BASE_URL,
} from "@/common/apiEndpoints.js";
import CompetitionFinishedDailog from "@/components/dialogComponents/CompetitionFinishedDailog.vue";
import CompetitionInstructions from "@/components/dialogComponents/CompetitionInstructionsDialog.vue";
import axios from "axios";
import { GET_TOKEN, GET_USER_TYPE } from "@/store/getters";
import { COMP_STATE_LIVE, COMP_STATE_UPCOMING } from "@/common/constants";
import { mapGetters, mapMutations } from "vuex";
import { getAxiosOptions, formatDateTime } from "@/common/utility";
import {
  SET_API_ERROR,
  SET_API_SUCCESS,
  SET_OVERLAY_VALUE,
  SET_PARAMS_VALUE,
} from "@/store/mutations";
export default {
  data() {
    return {
      loading: true,
      studentCompetitions: [],
      filteredCompetitions: [],
      loadingLive: true,
      compLeaderboard: {},
      selectedOption: "LIVE",
      compAnalysis: {},
      coinValue: 70,
      studentPreviousCompetitions: {},
      COMP_STATE_LIVE: COMP_STATE_LIVE,
      COMP_STATE_UPCOMING: COMP_STATE_UPCOMING,
      quizComp: { quizes: [] },
      answered: 0,
      notAnswered: 0,
      quizContent: { quizQuestions: [] },
      quizID: "",
      quizScore: 0,
      earnedCoins: 2,
      searchQuery: "",
      timerInterval: null,
      stateConfig: {
        LIVE: { text: "Live", color: "red", next: "UPCOMING" },
        UPCOMING: { text: "Upcoming", color: "green", next: "LIVE" },
      },
    };
  },
  computed: {
    ...mapGetters({
      userType: `schoolModule/${GET_USER_TYPE}`,
      token: `schoolModule/${GET_TOKEN}`,
    }),
    options() {
      return [
        { text: "Live", value: "LIVE" },
        { text: "Upcoming", value: "UPCOMING" },
        { text: "Finished", value: "FINISHED" },
      ];
    },
    currentState() {
      return this.stateConfig[this.selectedOption];
    },
    nextState() {
      return this.stateConfig[this.currentState.next];
    },
  },
  components: {
    CompetitionFinishedDailog,
    CompetitionInstructions,
  },
  mounted: function () {
    this.fetchCompetition(this.selectedOption);
    if (this.$route.params.compFinished) {
      this.$refs.competitionFinishedDialog.openDialog();
    }
  },
  beforeDestroy: function () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  methods: {
    updateCompetitions() {
      const currentTime = new Date();
      this.studentCompetitions.forEach((comp) => {
        if (
          comp.state === "UPCOMING" &&
          currentTime >= new Date(comp.startDate)
        ) {
          comp.state = "LIVE";
        } else if (
          comp.state === "LIVE" &&
          currentTime >= new Date(comp.endDate)
        ) {
          comp.state = "FINISHED";
        }
      });
    },

    updateTimeDifferences() {
      this.studentCompetitions.forEach((comp) => {
        comp.timeStartDifference = this.getTimeDifference(comp.startDate);
        comp.timeEndDifference = this.getTimeDifference(comp.endDate);
        comp.timeResultDifference = this.getTimeDifference(comp.endDate);
      });
      this.$forceUpdate();
    },
    ...mapMutations({
      setApiError: `schoolModule/${SET_API_ERROR}`,
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
      setParams: `schoolModule/${SET_PARAMS_VALUE}`,
    }),
    analyseComp(comp) {
      var compParams = {};
      compParams.competition = comp;
      this.setParams(compParams);
      this.$router.push({
        name: "CompetitionAnalytics",
        params: { durationTime: comp.duration },
      });
    },
    openCompetiitonFinishedDialog() {
      this.$refs.competitionFinishedDialog.openDialog();
    },
    getTimeDifference(date) {
      const now = new Date();
      const targetDate = new Date(date);
      const diff = targetDate - now;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      if (days > 0) {
        return `${days} days ${hours} hours`;
      }
      if (days === 0 && hours > 0) {
        return `${hours} hours ${minutes} mins`;
      }
      if (days === 0 && hours === 0 && minutes > 0) {
        return `${minutes} mins ${seconds} secs`;
      }
      return `${seconds} secs`;
    },
    fetchCompetition(compState) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.setOverlayValue(true);
      this.loading = true;
      this.selectedOption = compState;
      let url = GET_ALL_STUDENT_COMPETITIONS + "?state=" + compState;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.studentCompetitions = res.data.competitions;
          this.updateTimeDifferences();
          this.updateCompetitions();
          this.filteredCompetitions = this.studentCompetitions;
          this.timerInterval = setInterval(() => {
            this.updateTimeDifferences();
            this.updateCompetitions();
          }, 1000);
          this.setOverlayValue(false);
          this.loadingLive = false;
          this.loading = false;
        })
        .catch((error) => {
          this.setOverlayValue(false);
          this.loadingLive = false;
          this.loading = false;
        });
    },
    getChipColor(state) {
      if (state == COMP_STATE_LIVE) {
        return "error-chip";
      } else if (state == COMP_STATE_UPCOMING) {
        return "success-chip";
      } else {
        return "secondary-chip";
      }
    },
    formatDateTime(date) {
      return formatDateTime(date);
    },
  },
};
</script>
<style>
.fixedbtn {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  z-index: 1;
}
.fixed-tab {
  position: fixed;
  top: 5.5rem;
  right: 3rem;
  z-index: 1000;
  background-color: transparent !important;
}

.tabs {
  display: flex;
}

.v-tab {
  min-width: auto;
  padding: 0 0.3rem;
  margin: 0 0.2rem;
  border-radius: 2rem;
  background-color: transparent !important;
  color: white;
}
</style>
